module.exports = __webpack_public_path__ + "img/Icon-Search-black.1f05ddf7.svg";